import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Request interceptor → añade token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("dths_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("❌ Error en request interceptor:", error);
    return Promise.reject(error);
  }
);

// ✅ Response interceptor → NO cerrar sesión a la ligera
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const code = error.response?.data?.code;

    console.error(
      "Error en response interceptor:",
      error.response?.data || error.message
    );

    // 🚨 SOLO si el backend confirma token inválido
    if (status === 401 && code === "TOKEN_INVALID") {
      console.warn("⚠️ Token inválido. Cerrando sesión.");
      localStorage.removeItem("dths_token");
      // window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default api;
